export const TcFilterCONSTANTS = {
  SMART_FORM_STORE_KEY_ENDING: '.filter',
  AUTO_OPEN: 'autoOpen',
};
